export const ClinicListCard = {
  extends: 'Link',
  href: (el, s) => '/clinic?id=' + s.id,
  textDecoration: 'none',
  color: 'inherit',
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid transparent',
  cursor: 'pointer',
  transition: 'all 0.25s ease',
  ':hover': { border: '1px solid inkBorder', boxShadow: '0 8px 24px rgba(0,0,0,0.06)' },
  show: (el, s) => {
    const q = s.root.clinicFilter
    if (!q) return true
    const lower = q.toLowerCase()
    return s.name.toLowerCase().includes(lower) || s.district.toLowerCase().includes(lower) || (s.services || []).some(sv => sv.toLowerCase().includes(lower))
  },

  CardHeader: {
    flow: 'x',
    align: 'flex-start space-between',
    gap: 'Z',
    HeaderLeft: {
      flow: 'x',
      align: 'flex-start flex-start',
      gap: 'Z',
      flex: '1',
      minWidth: '0',
      ClinicLogo: {
        tag: 'img',
        width: 'C',
        height: 'C',
        round: 'Z',
        flexShrink: '0',
        attr: { src: (el, s) => s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.name) + '&background=0D1117&color=00C9A7&size=96&bold=true&format=svg' }
      },
      NameGroup: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        ClinicName: { text: (el, s) => s.name, fontSize: 'A', fontWeight: '600', color: 'inkText', lineHeight: '1.3' },
        ClinicLoc: {
          flow: 'x',
          gap: 'Y',
          align: 'center flex-start',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: '100%',
          LocDistrict: { text: (el, s) => s.district, fontSize: 'Z', color: 'inkText', fontWeight: '500', flexShrink: '0' },
          LocDot: { text: '·', fontSize: 'Z', color: 'inkMuted', flexShrink: '0' },
          LocAddress: { text: (el, s) => s.address, fontSize: 'Z', color: 'inkMuted', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: '0' }
        }
      }
    },
    RatingBadge: {
      flow: 'x',
      gap: 'W',
      align: 'center center',
      padding: 'W Y',
      round: 'Y',
      background: 'teal.1',
      flexShrink: '0',
      RatingStar: { extends: 'Icon', icon: 'star', width: 'Z', height: 'Z', color: 'teal' },
      RatingVal: { text: (el, s) => String(s.rating), fontSize: 'Z', fontWeight: '600', color: 'teal' }
    }
  },

  DiscountBadge: {
    show: (el, s) => {
      const discounts = s.root.clinicDiscounts
      return discounts && discounts[s.id]
    },
    flow: 'x',
    gap: 'W',
    align: 'center center',
    padding: 'W Y',
    round: 'Y',
    background: 'teal.15',
    marginTop: 'Y',
    width: 'fit-content',
    BadgeIcon: { extends: 'Icon', icon: 'tag', width: 'Y', height: 'Y', color: 'teal' },
    BadgeText: { text: '{{ specialOffer | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'teal' }
  },

  CardMeta: {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    align: 'center flex-start',
    marginTop: 'Y',
    color: 'inkMuted',
    fontSize: 'Z',
    MetaReviews: { text: (el, s) => s.reviews + ' reviews' },
    MetaDot1: { text: '·' },
    MetaHours: { text: (el, s) => s.hours },
    MetaDot2: { text: '·', show: (el, s) => !s.root.hidePrices },
    MetaPrice: { text: (el, s) => s.priceRange, show: (el, s) => !s.root.hidePrices }
  },

  CardServices: {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    marginTop: 'Y',
    children: (el, s) => (s.services || []).map(sv => ({ label: sv })),
    childrenAs: 'state',
    childProps: {
      text: (el, s) => s.label,
      fontSize: 'Z',
      padding: 'X Z',
      round: 'C',
      background: 'inkSurface',
      color: 'inkSubtle',
      fontWeight: '500'
    }
  }
}
